
const SET_COMPLETE = '[exam][content][sections][section]set.complete';
const SET_TIME_REMAINING = '[exam][content][sections][section]set.time.remaining';
const SET_READING_TIME_REMAINING = '[exam][content][sections][section]set.reading.time.remaining';
const SET_AUDIO_ELAPSED = '[exam][content][sections][section]set.audio_elapsed';
const SET_AUDIO_STATE = '[exam][content][sections][section]set.audio_state';

export {SET_COMPLETE, SET_TIME_REMAINING, SET_READING_TIME_REMAINING, SET_AUDIO_ELAPSED, SET_AUDIO_STATE}